/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {BranchState} from './BranchState';

// eslint-disable-next-line typescript/no-explicit-any -- Pre-existing any
type WorkroundRootState = Record<string, any> & {
  branch: BranchState;
};

export const selectActiveBranchId = ({branch}: WorkroundRootState) => branch?.activeBranchId;
export const selectDefaultBranchId = ({branch}: WorkroundRootState) => branch.defaultBranchId;
export const selectUserBranchOptions = ({branch}: WorkroundRootState) => branch.userOptions;
